import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import Lang from 'vuejs-localization'
import CONFIG from './config/config'
import './assets/css/main.scss'
import veeValidate, {
  Validator
} from 'vee-validate'
import messagesEn from './assets/strings/validator/en_messages.js'

Vue.config.productionTip = false

Lang.requireAll(require.context('./locale', true, /\.js$/))
Vue.prototype.$hostname = CONFIG.developmentMode ? CONFIG.serverBaseUrl : '/'
Vue.prototype.$hostnameStatic = CONFIG.developmentMode ?
  CONFIG.clientBaseUrl :
  '/'
Vue.prototype.$nodeDefaultBrandsUrl = CONFIG.nodeDefaultBrandsUrl
Vue.prototype.$nodeBrandsUrl = CONFIG.nodeCobrandBrandsUrl
Vue.prototype.$finappIframeUrl = CONFIG.finappIframeUrl
Vue.prototype.$nodeUrl = CONFIG.nodeUrl
Vue.prototype.$skipLoginValidation = CONFIG.skipLoginValidation
Vue.prototype.$enableNewDesign = window.APPCONFIG.appUXVersion == '1.1' ? true : false;
Vue.use(vuetify)
Vue.use(Lang)
Vue.use(ElementUI, {
  locale
})

const dictionary = {
  en: {
    messages: messagesEn
  }
}

// Merge the locales.
Validator.localize(dictionary)

Vue.use(veeValidate, {
  fieldsBagName: 'formFields',
  inject: false
})

const $ = require('jquery')
window.$ = $

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

$(document).on('click', (evt) => {
  if ($(evt.target).parents(".session-timeout-popup").length === 0 && !$(evt.target).hasClass("v-overlay__scrim")) {
    store.state.appStore.sessionManagement.resetSession = false
    store.state.appStore.sessionManagement.resetSession = true
  }
})